import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setReferenciaConsultaPensionistasADMRH: ['referencia'],
    limpaFiltroConsultaPensionistasADMRH: [],
    receberFiltroConsultaPensionistasADMRH: ['filtroRecebido'],
    setStatusConsultaPensionistasADMRH: ['status'],
})

const INITIAL_STATE = {
    referencia: '',
    status: { label: '', value: '' },
}

const setReferencia = (state = INITIAL_STATE, action) => {
    return { ...state, referencia: action.referencia }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_REFERENCIA_CONSULTA_PENSIONISTAS_ADMRH]: setReferencia,
    [Types.LIMPA_FILTRO_CONSULTA_PENSIONISTAS_ADMRH]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_PENSIONISTAS_ADMRH]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_PENSIONISTAS_ADMRH]: setStatus,
})
